import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";

import img1 from "../../img/newabout-page.png";
import img2 from "../../img/newcars.png";

import "./style.css";

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="about-page-area section_70">
        <Container>
          <Row>
           <Col lg={6}>
  <div className="about-page-left">
    <h4>About Sher East Africa</h4>
    <h3>"Luxury Safari Vehicles Built for Africa’s Toughest Terrain"</h3>
    <p>
      Sher East Africa is a premium safari transport company based in Arusha, Tanzania, specializing in Toyota Land Cruiser 70 Series vehicles designed for rugged off-road terrain without compromising comfort and class. We combine strength, reliability, and refined travel to deliver exceptional safari experiences.
    </p>
    <p>
      Whether exploring national parks, attending exclusive events, or arranging private transfers, our professional drivers and well-maintained fleet ensure safety, performance, and luxury in every journey. We don’t just provide transport — we deliver unforgettable travel experiences.
    </p>
    <div className="about-page-call">
      <div className="page-call-icon">
        <FaPhoneAlt />
      </div>
      <div className="call-info">
        <p>{t("need_any_help")}</p>
        <h4>
          <a href="tel:+255783339124">+255 783 339 124</a>
        </h4>
      </div>
    </div>
  </div>
</Col>

            <Col lg={6}>
              <div className="about-page-right">
                <img src={img1} alt="about page" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="gauto-about-promo section_70">
        <Container>
          <Row>
            <Col md={12}>
              <div className="about-promo-text">
                <h3
                  dangerouslySetInnerHTML={{
                    __html: t("about_page.proud_title", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                ></h3>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="about-promo-image">
                <img src={img2} alt="about promo" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AboutPage;
